<template>
	<div>
		<data-list
			style="margin-top: 10px"
			:data="data"
			:columns="columns"
			:loading="loading"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
			:table-style="{ name: 'mixture' }"
		></data-list>
	</div>
</template>

<script>
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
const page = listPageCreate({
	searchConfig: {
		api: api.customer.orderlist,
		method: 'POST',
	},
	getQuery(obj, that) {
		return _.assign(obj, {
			customerId: that.$route.query.id,
		});
	},
});
export default {
	mixins: [page],
	props: {
		columns: Array,
	},
	data() {
		return {};
	},
	methods: {},
	mounted() {
		this.query();
	},
	components: {},
};
</script>

<style></style>
